<template>
  <div class="pageWrap">
    <!-- 导航栏 -->
    <navi-header :isScroll="isScroll" ></navi-header>
    <iframe :src="src" frameborder="0" style="width: 100%; height: 100%">
    </iframe>
  </div>
</template>

<script>
import { debounce } from "../utils/util.js";
import naviHeader from '@/components/naviHeader.vue';
export default {
  data(){
    return{
      src:"http://h5.ppj.io/p6obWw7d/index.html?v=115",
      isScroll: true,
      screenWidth: null,
    }
  },

  components:{
      naviHeader
    },

  mounted(){
    
  },
}
</script>

<style scoped>
.pageWrap {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 1);
  /* background: green; */
  margin: 0;
  color: #fff;
  padding-top: 80px;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/pages/chengji.vue